import jQuery from 'jquery';
import bootstrap from 'bootstrap';
import ScrollMagic from 'scrollmagic';

jQuery(document).ready(() => {
    const breakNavProduct = document.querySelector('.breakNavProduct'),
        blocFixed = document.querySelector('.blocFixed'),
        mainContent = document.querySelector('#mainContent'),
        zoneReassurance = document.querySelector('.zoneReassurance'),
        blocRecap = document.querySelector('.blocRecap'),
        magicController = new ScrollMagic.Controller();

    // bloc fixed nav product dans page produit
    if(breakNavProduct && anchorBasDesc) {
      const navProductItems = document.querySelectorAll('.navProductItem');
        
      for (let i = 0; i < navProductItems.length; i++) {
        navProductItems[i].addEventListener('click', () => {
            let scrollTop = $(navProductItems[i].getAttribute('data-href')).offset().top;
            if (!$('.navProduct').hasClass('p-fixed'))  {
                scrollTop = scrollTop - 50;
            }
          $('html, body').animate({ scrollTop: scrollTop }, 400);
        });
      }
        
      new ScrollMagic.Scene({
        offset: 400,
        triggerElement: breakNavProduct
      }).on('enter', () => {
        blocFixed.classList.add('p-fixed');
      }).on('leave', () => {
        blocFixed.classList.remove('p-fixed');
      }).addTo(magicController);
    }

    // Bloc recap dans panier
    if(blocRecap && zoneReassurance) {
      const calc_offset = document.querySelector('.blocRecap').offsetHeight - 334;

        new ScrollMagic.Scene({
            offset: 400,
            triggerElement: mainContent
        }).on('enter', () => {
            blocRecap.classList.add('p-fixed');
        }).on('leave', () => {
            blocRecap.classList.remove('p-fixed');
        }).addTo(magicController);

        new ScrollMagic.Scene({
          offset: -115 - calc_offset,
          triggerElement: zoneReassurance
        }).on('enter', () => {
          blocRecap.classList.add('p-absolute');
          blocRecap.classList.remove('p-fixed');
        }).on('leave', () => {
          blocRecap.classList.remove('p-absolute');
          blocRecap.classList.add('p-fixed');
        }).addTo(magicController);
    }
});



// WEBPACK FOOTER //
// ./src/SiteBundle/Resources/assets/js/scroll.js